import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/MicrosoftPartnerSection.css';
import BusinessPeopleMeeting from '../../assets/business-people-meeting.png';

const MicrosoftPartnerSection = () => {
  return (
    <section className="microsoft-partner-section">
      <div className="microsoft-partner-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <aside ref={ref} className={`microsoft-partner-image ${inView ? 'animate' : ''}`}>
              <figure>
                <img src={BusinessPeopleMeeting} alt="Business professionals collaborating in a modern digital workplace meeting" className="business-people-image" />
              </figure>
            </aside>
          )}
        </InView>
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <article ref={ref} className={`microsoft-partner-content ${inView ? 'animate' : ''}`}>
              <header>
                <h1>Partner with us to accelerate your shift to a modern digital workplace through our:</h1>
              </header>
              <ul className="partner-benefits">
                <li>Expertise in maximizing productivity with Microsoft 365, including Teams, Loop, and AI-powered Microsoft 365 Copilot.</li>
                <li>Delivery of cost-effective, cloud-based collaboration with Microsoft Teams, SharePoint Online, and Viva.</li>
                <li>Insights of data-driven decisions with real-time insights from Power BI and Microsoft Fabric integration.</li>
                <li>Ability to extend Microsoft 365 capabilities with tailored managed services and advanced security, compliance, and automation solutions.</li>
              </ul>
            </article>
          )}
        </InView>
      </div>
    </section>
  );
};

export default MicrosoftPartnerSection;